import classNames from "classnames";
import React from "react";

import TextInputComponent from "./TextInputComponent";

export default function TextInputContainer({
  label = null,
  labelClasses = "",
  floatingLabel = false,
  placeholder,
  onChange,
  onKeyUp,
  onFocus,
  value,
  hasIcon,
  type = "text",
  disabled = false,
  maxLength,
  required,
  autoFocus = false,
  startIcon,
  endIcon,
  onIconClick,
  variant = "primary",
  customClassName = "",
  name,
  max,
  min,
  defaultValue = "",
  onKeyDown,
  width,
  onBlur,
  autoComplete = "on",
}) {
  const variantClass = classNames({
    "disabled:bg-purple-100 hover:shadow-space-stroke-4": variant === "primary",
    "border-space-200 disabled:bg-space-30": variant === "outline-secondary",
    "border-error": variant === "outline-danger",
  });
  return (
    <TextInputComponent
      {...{
        width,
        label,
        labelClasses,
        placeholder,
        onChange,
        onKeyUp,
        onFocus,
        value,
        hasIcon,
        type,
        disabled,
        maxLength,
        required,
        autoFocus,
        startIcon,
        endIcon,
        onIconClick,
        variantClass,
        customClassName,
        floatingLabel,
        name,
        max,
        min,
        defaultValue,
        onKeyDown,
        onBlur,
        autoComplete,
      }}
    />
  );
}
